<template>
	<v-card>
		<form @submit.prevent="save" class="fill-height  d-flex flex-column justify-space-between">
			<div>
				<v-toolbar dark class="p3" color="#ed217c">
					<v-toolbar-title>
						<h4 class="px-4">{{ $t('Center Management') }}</h4>
					</v-toolbar-title>
				</v-toolbar>
				<v-card-text>
					<smart-input :required="true" :label="$t('Center Management')" v-model="form.name" :error="errors.name"/>
				</v-card-text>
			</div>
			<v-card-actions>
				<v-btn type="submit" color="success" :loading="inProgress">
					<v-icon>save</v-icon>
					{{ $t('generics.save') }}
				</v-btn>
			</v-card-actions>
		</form>
	</v-card>
</template>

<script>
import CompanyService from "../../services/CompanyService";
import AuthModule from "../../store/modules/Auth.module";
import LaravelErrors from "../../helpers/LaravelErrors";

export default {
	name: "CenterForm",
	props: {
		company: Object,
	},
	data () {
		return {
			inProgress: false,
			form: {
				name: null,
			},
			errors: {},
		};
	},
	created () {
		this.form.name = this.company?.name;
	},
	methods: {
		async save () {
			try {
				this.errors = {};
				this.inProgress = true;
				await CompanyService.save(Object.assign(this.company, this.form));
				this.$store.dispatch(AuthModule.types.GET);
				this.$notification.success();

			} catch (e) {
				this.errors = LaravelErrors.getErrorsFromResponseError(e);
			}
			this.inProgress = false;
		},
	},
};
</script>

<style scoped>

</style>
